import { ReactComponent as MainLogoSvg } from 'assets/svg/Main-Logo.svg';

const HelloDataMark = () => <MainLogoSvg />;

export default HelloDataMark;
